
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "RepairSolution",
components: {XHeader, XButton, Cell},
data() {
return {
solutionList: this.$route.params.solution,
seq: this.$route.params.seq,
role: this.$route.params.role,
type: this.$route.params.type,
solutionv: this.$route.params.solutionv,
show: this.$route.params.show === false ? this.$route.params.show : true
}
},
methods: {
addRate() {
this.$router.push({
name: 'addrate',
params: {rate: this.solutionList ? this.solutionList.content : [], solutionv: this.solutionv}
})
}
},
created() {
if (this.solutionv === 2) {
this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_solutions?role=' + this.role + '&offset=0&count=999', {
headers: {
token: localStorage.getItem("token"),
opid: localStorage.getItem("userid")
}
}).then(resposne => {
this.solutionList = resposne.data
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
}
},
beforeRouteLeave(to, from, next) {
if (to.name === 'RepairSrvp') {
to.params.seq = this.seq;
to.params.type = this.type;
to.params.role = this.role;
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/repairs/RepairSolution.vue